module.exports = __webpack_public_path__ + "img/stackslash-process-5-mobile.df0df4df.jpg";